<template>
<div id="cartaporte">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="mdi-note-text" title="Nueva Nota de Crédito" class="elevation-1 ">

                    <v-card-text>
                        <v-container>
                            <v-form ref="form">
                                <div style="width:95%; position:absolute; top:0px;">
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6">
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6">
                                            <v-alert color="green" outlined dense type="info"><span style="font-size:10px;">Si no se específica la Serie y Folio el sistema asignara en automático el de la configuración.</span></v-alert>

                                        </v-col>

                                    </v-row>
                                    <v-row style="width:100%; position:absolute; top:45px; left:10px;">
                                        <v-col sm="6" md="6" lg="6">
                                        </v-col>
                                        <v-col sm="3" md="3" lg="3">
                                            <v-text-field v-if="series.length==0" v-model="model.serie" label="Serie"></v-text-field>
                                            <v-autocomplete v-if="series.length>0" v-model="model.serie" label="Serie" :items="series" clearable item-text="text" item-value="id">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col sm="3" md="3" lg="3">
                                            <v-text-field v-model="model.folio" label="Folio"></v-text-field>
                                        </v-col>
                                    </v-row>

                                </div>
                                <p />
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <h5><b>Emisor</b> </h5><span class="title">{{model.emisor.rfc}} - {{model.emisor.razon_social}}</span>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-menu
                                            v-model="menu1"
                                            :close-on-content-click="false"
                                            max-width="290"
                                            >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                :value="model.FechaPago"
                                                label="Fecha"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                @click:clear="model.FechaPago = null"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="model.FechaPago" no-title locale="MX"
                                                @change="menu1 = false"
                                            ></v-date-picker>
                                            </v-menu>
                                    </v-col>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete v-model="model.receptor" label="Receptor" return-object :items="receptores" :hide-no-data="true" item-text="razon_social" item-value="uuid" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.rfc}} - {{ item.razon_social}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.rfc}} - {{ item.razon_social}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                               

                                <p />
                               
                                <v-row>
                                <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete v-model="model.UsoCFDI" label="Uso CFDI" :items="UsosCFDI" :hide-no-data="true" item-text="nombre" item-value="clave" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.clave}} - {{ item.nombre}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.clave}} - {{ item.nombre}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                              
                                <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete v-model="model.FormaPago" label="Forma Pago" :items="FormasPago" :hide-no-data="true" item-text="nombre" item-value="clave" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.clave}} - {{ item.nombre}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.clave}} - {{ item.nombre}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <p />
                                <v-row>
                                   
                                   <v-col sm="6" md="6" lg="6">
                                       <v-text-field v-model="model.UUID" label="Folio Fiscal UUID" :rules="[rules.required]"></v-text-field>
                                   </v-col>

                             
                                        <v-col sm="6" md="6" lg="6">
                                                    <v-autocomplete v-model="model.TipoRelacion" label="Tipo de Relación" :items="TiposRelacion" :hide-no-data="true" item-text="descripcion" item-value="clave" :rules="[rules.required]">
                                                        <template v-slot:selection="{ attrs, item, parent, selected }">
                                                            <span class="pr-2">
                                                                {{item.clave}} - {{ item.descripcion}}
                                                            </span>
                                                        </template>
                                                        <template v-slot:item="{ index, item }">
                                                            {{item.clave}} - {{ item.descripcion}}
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                            </v-row>
                                        <p />
                                        <v-row>
                                    
                                        
                                            <v-col sm="6" md="6" lg="6">
                                                <v-text-field v-model="model.Descripcion"  label="Descripción" :rules="[rules.required]"></v-text-field>
                                            </v-col>
                                            <v-col sm="2" md="2" lg="2">
                                                <v-text-field v-model="model.Pago.Saldo" label="Importe" @change="calcular_totales" :rules="[rules.required]"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                         <v-col   sm="2" md="2" lg="2">
                                            <h5 style="color:green">IMPUESTOS </h5>
                                        </v-col>
                                    <v-col  sm="2" md="2" lg="2">
                                        <v-text-field v-model="iva_traslado" label="% IVA Trasladado" @change="calcular_totales"></v-text-field>
                                    </v-col>
                                    <v-col  sm="2" md="2" lg="2">
                                        <v-text-field v-model="iva_retenido" label="% IVA Retendido" @change="calcular_totales"></v-text-field>
                                    </v-col>
                                    <v-col  sm="2" md="2" lg="2">
                                        <v-text-field v-model="isr_retenido" label="% ISR Retenido" @change="calcular_totales"></v-text-field>
                                    </v-col>
                                   
                                </v-row>
                                <p />
                                <div  >
                                <v-row>
                                    <v-spacer />
                                    <v-col class="text-right overline font-weight-bold" sm="2" md="2" lg="2">
                                        SUBTOTAL:
                                    </v-col>
                                    <v-col class=" text-right overline font-weight-bold" sm="1" md="1" lg="1">
                                        {{subtotal_factura}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-spacer />
                                    <v-col class="text-right  overline font-weight-bold" sm="2" md="2" lg="2">
                                        IMPUESTOS TRASLADADOS:
                                    </v-col>
                                    <v-col class="text-right  overline font-weight-bold" sm="1" md="1" lg="1">
                                       {{imp_traslado_factura}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-spacer />
                                    <v-col class="text-right  overline font-weight-bold" sm="2" md="2" lg="2">
                                        IMPUESTOS RETENIDOS:
                                    </v-col>
                                    <v-col class="text-right  overline font-weight-bold" sm="1" md="1" lg="1">
                                        {{imp_retenido_factura}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-spacer />
                                    <v-col class="text-right  overline font-weight-bold" sm="2" md="2" lg="2">
                                        TOTAL:
                                    </v-col>
                                    <v-col  class="text-right  overline font-weight-bold" sm="1" md="1" lg="1">
                                        {{total_factura}}
                                    </v-col>
                                </v-row>
                                </div>
                              
                            </v-form>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                 

                        <v-btn color="success" large @click.native="timbrar()">
                            <v-icon>mdi-qrcode</v-icon> Generar CFDI
                        </v-btn>
                    </v-card-actions>
                </base-material-card>
                <pre>
                {{timbre}}
                </pre>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import isValidMomentObject from "vue-tables-2/compiled/helpers/is-valid-moment-object";

export default {
    name: "DashboardDataTables",

    data: () => ({
        series: [],
        url: 'https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/',
        nota: "",
        menu1: false,
        computedDateFormatted: "",
        impuestos: "",
        model: {
            total_factura: "0.00",
            subtotal_factura: "0.00",
            imp_traslado_factura: "0.00",
            imp_retenido_factura: "0.00",
            isr_retenido: 0,
            iva_traslado: 0,
            iva_retenido: 0,
            concarta: true,
            serie: "",
            folio: "",
            UsoCFDI: "G03",
            Moneda: "MXN",
            TipoDeComprobante: "T",
            LugarExpedicion: "06300",
            TipoRelacion: "01",
            FormaPago:"03",
            UUID: "",
            FechaPago: "",
            TipoCambio: "1",
            MetodoPago: "PUE",
            Descripcion:"",
            emisor: "",
            Pago: {
                No: "1",
                Saldo: "",
                Pagado: "",
                Insoluto: ""
            },
            receptor: {
                "registro_fiscal": ""
            },
            uuid_empresa: "",
            uuid_licencia: "",
            uuid: "",
            estatus: "",
            fecha: "",
            tipo: "",
            observaciones: "",
        },
        total_factura: "0.00",
        subtotal_factura: "0.00",
        imp_traslado_factura: "0.00",
        imp_retenido_factura: "0.00",

        isr_retenido: 0,
        descuento_factura: "0.00",
        iva_traslado: 0,
        iva_retenido: 0,
        descuento: 0,
        subtotal_producto: 0,
        total_producto: 0,
        producto: "",
        cantidad: 1,
        producto2: "",
        cantidad2: 1,
        nota: "",
        precio: 0,
        UsosCFDI: [],
        FormasPago: [],
        TiposRelacion: [], 
        MetodosPago: [],
        Monedas: [{
                clave: "MXN",
                nombre: "PESO MEXICANO"
            },
            {
                clave: "USD",
                nombre: "DOLAR ESTADOUNIDENCE"
            },
            {
                clave: "EUR",
                nombre: "EURO"
            }
        ],
        TiposDeComprobante: [{
                clave: "T",
                nombre: "TRASLADO"
            },
            {
                clave: "I",
                nombre: "INGRESO"
            },
        ],
        timbre: "",
        tabla: "carta_porte",
        uuid_editando: "",
        con_mercancias: false,
        origenes: [],
        destinos: [],
        receptores: [],
        remolques: [],
        figuras: [],
        transportes: [],
        productos: [],
        mercancias: [],
        modal: false,
        usuario: "",
        clientes: [],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "Pago",
                disabled: true,
                href: "",
            },
        ],
        rules: {},
        columns_productos: ["producto.nombre", "cantidad", "precio", "subtotal", "descuento", "iva_traslado", "iva_retenido", "total", "actions"],
        options_productos: {
            filterable: false,
            headings: {
                'producto.nombre': "Producto",
                catidad: "Cantidad",
                'precio': "Precio",
                "subtotal": "Subtotal",
                "descuento": "Descuento",
                "iva_traslado": "Trasladado",
                "iva_retenido": "Retenido",
                "total": "Total",
                actions: "Operaciones"
            }
        },
        columns_mercancias: ["producto.nombre", "cantidad", "nota", "actions"],
        options_mercancias: {
            filterable: false,
            headings: {
                'producto.nombre': "Mercancia",
                catidad: "Cantidad",
                nota: "Nota",
                actions: "Operaciones"
            }
        },
        columns_mercancias_sincarta: ["producto.nombre", "cantidad", "actions"],
        options_mercancias_sincarta: {
            filterable: false,
            headings: {
                'producto.nombre': "Producto",
                catidad: "Cantidad",
                actions: "Operaciones"
            }
        },
        items: [],
    }),
    computed: {
        nombre() {
            let nombre_usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
            return nombre_usuario;
        }
    },
    methods: {
        validaRemolque: function () {
            try {
                if (this.model.remolque1 != undefined && this.model.remolque1 != null && this.model.remolque1 != "")
                    if (this.model.remolque1 == this.model.remolque2)
                        return "Remolque se encuentra duplicado";

                return true;
            } catch (error) {
                return true;
            }
        },
        calcular_totales: function(){
            let self = this;
            self.subtotal_factura = parseFloat(self.model.Pago.Saldo);
            var iva = ((parseFloat(self.iva_retenido) * self.subtotal_factura) / 100 ).toFixed(2);
            var isr = ((parseFloat(self.isr_retenido)*self.subtotal_factura)/100).toFixed(2);
            self.imp_retenido_factura = parseFloat(iva) +  parseFloat(isr);
            self.imp_traslado_factura = ((parseFloat(self.iva_traslado) * self.subtotal_factura) / 100).toFixed(2);
            self.total_factura = parseFloat(self.subtotal_factura) + parseFloat(self.imp_traslado_factura) - parseFloat(self.imp_retenido_factura);

            self.total_factura = self.total_factura.toFixed(2);
            self.subtotal_factura = self.subtotal_factura.toFixed(2);
        },
        actualizaSaldo: function () {

            if (parseFloat(this.model.Pago.Saldo) > 0 && parseFloat(this.model.Pago.Pagado) > 0)
                this.model.Pago.Insoluto = parseFloat(this.model.Pago.Saldo) - parseFloat(this.model.Pago.Pagado);
            else
                this.model.Pago.Insoluto = "";
        },
      
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },

        cargarCatalogosSAT: async function () {
            var self = this;

            this.$axios.post(this.URL_SAT + "list_usos_cfdi/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.UsosCFDI = res.data;
                    }
                });

           await this.$axios.post(this.URL_SAT + "list_formas_pago/")
                .then(res => {
                    if (typeof res.data !== "undefined") {

                        self.FormasPago = res.data.sort(function (a, b) {
                            if (parseInt(a.clave) > parseInt(b.clave))
                                return 1;
                            if (parseInt(a.clave) < parseInt(b.clave))
                                return -1;
                            return 0;
                        });
                    }
                });
              await  this.$axios.post(this.URL_SAT + "list_tipos_relacion/")
                .then(res => {
                    if (typeof res.data !== "undefined") {

                        self.TiposRelacion = res.data.sort(function (a, b) {
                            if (parseInt(a.clave) > parseInt(b.clave))
                                return 1;
                            if (parseInt(a.clave) < parseInt(b.clave))
                                return -1;
                            return 0;
                        });
                    }
                });    
           await this.$axios.post(this.URL_SAT + "list_metodos_pago/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.MetodosPago = res.data;
                    }
                });

        },
        cargar: async function (id) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;

            var data = {
                "uuid_empresa": this.model.uuid_empresa,
                "filtros": {
                    "uuid": id
                }
            };
         await   axios.post(this.$hostname + 'carta_porte/list_pre_carta_porte/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.model = res.data[0];
                        if (self.model.concarta == true)
                            self.cargarDestinos();

                        self.calcular_totales();
                        self.cargarProductos();
                        self.$root.$dialogLoader.hide();
                    }

                });

        },
   
        cargarOrigenes: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                "uuid_empresa": this.model.uuid_empresa,
            };
          await  axios.post(self.URL + 'list_ubicaciones/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.origenes = res.data;
                    }
                });

            this.$root.$dialogLoader.hide();
        },
        cargarDestinos: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");

            var data = {
                "uuid_empresa": this.model.uuid_empresa,
            };
          await  axios.post(self.URL + 'list_ubicaciones/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.destinos = res.data;
                    }
                });

            this.$root.$dialogLoader.hide();
        },
        cargarEmisor: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                filtros: {
                    "uuid": this.model.uuid_empresa
                }
            };
       await     axios.post(self.URL_ADM + 'list_empresas/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {

                        self.model.emisor = res.data[0];
                        
                        self.model.LugarExpedicion = self.model.emisor.domicilio.codigo_postal;
                        if (res.data[0].catalogo_series != undefined && res.data[0].catalogo_series.length > 0) {
                            res.data[0].catalogo_series.forEach(function (x) {
                                self.series.push({
                                    "id": x.serie,
                                    "text": x.serie
                                });
                            });
                        }
                        self.cargarOrigenes();
                        self.cargarDestinos();

                    }
                    self.$root.$dialogLoader.hide();
                });
        },
        cargarReceptores: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            let rfc = this.$local_storage.get('RFC_RECEPTOR');
            if(rfc != null)
                var data = {
                "uuid_empresa": this.model.uuid_empresa,
                "rfc":this.$local_storage.get('RFC_RECEPTOR')
                }
            else
                var data = {
                    "uuid_empresa": this.model.uuid_empresa
                }
          await  axios.post(self.URL + 'list_clientes/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.receptores = res.data;
                       
                        
                        var filter =self.receptores;
                            self.model.receptor = filter[0];
                            if(filter.length == 0){
                              let r =  JSON.parse(self.$local_storage.get('RECEPTOR'));
                           
                             
                              var record = {};
                              record.rfc = r.Rfc;
                              record.razon_social = r.Nombre;
                              record.regimen_fiscal_receptor = r.RegimenFiscalReceptor;
                              record.domicilio = {};
                              if(r.Domicilio != undefined){
                                record.domicilio.calle = r.Domicilio.Calle;
                                record.domicilio.codigo_postal = r.Domicilio.CodigoPostal;
                                record.domicilio.colonia = r.Domicilio.Colonia;
                                record.domicilio.estado = r.Domicilio.Estado;
                                record.domicilio.localidad = r.Domicilio.Localidad;
                                record.domicilio.municipio = r.Domicilio.Municipio;
                                record.domicilio.numero_ext = r.Domicilio.NumeroExterior;
                                record.domicilio.pais = r.Domicilio.Pais;
                              }else{
                                record.domicilio.calle = "";
                                record.domicilio.codigo_postal = "";
                                record.domicilio.colonia = "";
                                record.domicilio.estado = "";
                                record.domicilio.localidad = "";
                                record.domicilio.municipio = "";
                                record.domicilio.numero_ext = "";
                                record.domicilio.pais = "";
                              }
                              
                              if(r.email != undefined)
                                record.email = r.Email;

                                self.receptores.push(record);
                                self.model.receptor = record;


                            }
                        
                    }
                    self.$root.$dialogLoader.hide();
                });
        },
  
       

      
      
        validar: function () {
            var self = this;
            if (this.$refs.form.validate()) {
                if (self.model.concarta == true) {
                    if (self.model.hora_salida == "") {
                        self.$swal({
                            type: "error",
                            title: "Datos Incompletos",
                            text: "Debe especificar fecha y hora de Salida",
                            footer: "",
                        });
                        return false;
                    }
                    if (self.model.hora_llegada == "") {
                        self.$swal({
                            type: "error",
                            title: "Datos Incompletos",
                            text: "Debe especificar fecha y hora de Llegada",
                            footer: "",
                        });
                        return false;
                    }
                    const hs = new Date(self.model.hora_salida);
                    const he = new Date(self.model.hora_llegada);

                    if (hs > he) {
                        self.$swal({
                            type: "error",
                            title: "Datos Incorrectos",
                            text: "La Fecha y Hora de Salida no puede ser mayor a la de entrada",
                            footer: "",
                        });
                        return false;
                    }
                }
          

                return true;

            } else {
                self.$swal({
                    type: "error",
                    title: "Datos Incompletos",
                    text: "Verifique la informacón y vuelva a intentarlo",
                    footer: "",
                });
                return false;
            }

        },
        enviarTimbrar: function () {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;

            self.$root.$dialogLoader.show("Espere un momento por favor..");

            var data = {
                "rfc": self.model.emisor.rfc,
                "json": self.timbre,
                "usuario":self.nombre
                
            };
            axios.post(self.url + 'carta_porte/guardar_mongo/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        
                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se envio correctamente. ",
                            footer: "No. de Solicitud: " + res.data.id_solicitud,
                        });
                        self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(res.data.id_solicitud));
                        self.$router.replace("/cartaporte");
                        self.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(''));
                    self.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al guardar el registro.",
                        footer: "",
                    });
                    self.$root.$dialogLoader.hide();
                });

        },

        guardar: function (item) {
            var self = this;

            if (this.validar()) {
                this.$root.$dialogLoader.show("Espere un momento por favor..");
                let uuid = self.$uuid.v4();
                let metodo = "save_pre_carta_porte/";

                if (self.model.TipoDeComprobante == 'T' && self.model.concarta == true) {
                    self.model.lista_mercancias = [];
                    self.model.Moneda = "MXN";
                    self.model.FormaPago = "01";
                    self.model.TipoCambio = "1";
                    self.model.MetodoPago = "PUE";
                    self.model.receptor = self.model.emisor;
                }
                let data = self.model;

                data.uuid = uuid;
                data.estatus = 0;
                data.fecha = moment().format("YYYY-MM-DD HH:mm:ss").replace(' ', 'T');
                data.tipo = "Web";
                let param = {
                    "datos": data
                }
           
                this.$axios.post(this.$hostname + "carta_porte/" + metodo, param)
                    .then(res => {

                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se guardó correctamente.",
                            footer: "",
                        });
                        self.$root.$dialogLoader.hide();
                        return true;

                    });
            } else {
                return false;
            }
        },
        cancelar: function () {

            this.$router.replace("/pre_carta_porte");
        },

        timbrar: function () {
            if (this.validar()) {
                this.$root.$dialogLoader.show("Espere un momento por favor..");

                var self = this;
               

                var tasa_iva_translado = (parseFloat(self.iva_traslado) /100).toFixed(6);
                var tasa_iva_retenido = (parseFloat(self.iva_retenido) /100).toFixed(6);
                var tasa_isr_retenido = (parseFloat(self.isr_retenido) /100).toFixed(6);
                var isr_retenido = (parseFloat(self.model.Pago.Saldo) * parseFloat(tasa_isr_retenido)).toFixed(2);
                var iva_retenido = (parseFloat(self.model.Pago.Saldo) * parseFloat(tasa_iva_retenido)).toFixed(2);
                var iva_traslado = (parseFloat(self.model.Pago.Saldo) * parseFloat(tasa_iva_translado)).toFixed(2);

               
                var subtotal = (parseFloat(self.model.Pago.Saldo)).toFixed(2).toString();
                var total = (parseFloat(self.model.Pago.Saldo) + parseFloat(iva_traslado) - parseFloat(isr_retenido) - parseFloat(iva_retenido) ).toFixed(2).toString();

                var traslados = [];
                var retenidos = [];
                var retenidos2 = [];

                if(self.iva_traslado > 0)
                    traslados.push({
                                    "Impuesto": "002",
                                    "TipoFactor": "Tasa",
                                    "TasaOCuota": tasa_iva_translado.toString(),
                                    "Base": subtotal,
                                    "Importe": iva_traslado
                                 });
                if(self.isr_retenido > 0){
                    retenidos.push({
                                    "Impuesto": "001",
                                    "TipoFactor": "Tasa",
                                    "TasaOCuota": tasa_isr_retenido.toString(),
                                    "Base": subtotal,
                                    "Importe": isr_retenido
                                 }); 
                    retenidos2.push({
                        "Impuesto": "001",
                        "Importe": isr_retenido
                    }); 
                                }   
                if(self.iva_retenido > 0){
                    retenidos.push({
                                    "Impuesto": "002",
                                    "TipoFactor": "Tasa",
                                    "TasaOCuota": tasa_iva_retenido.toString(),
                                    "Base": subtotal,
                                    "Importe": iva_retenido
                                 }); 
                    retenidos2.push({
                        "Impuesto": "002",
                        "Importe": iva_retenido
                    }); 
                                }

                var impuestos = { 
                    "Traslados": traslados, 
                    "Retenciones": retenidos
                }
                var impuestos2 = { 
                    "Traslados": traslados, 
                    "Retenciones": retenidos2,
                    "TotalImpuestosRetenidos": (parseFloat(isr_retenido) + parseFloat(iva_retenido)).toString(),
                    "TotalImpuestosTrasladados": (parseFloat(iva_traslado)).toString()
                }    
               if(retenidos.length == 0){
                delete impuestos["Retenciones"];
                delete impuestos2["Retenciones"];
               }
                    
               if(traslados.length == 0){
                delete impuestos["Traslados"];
                delete impuestos2["Traslados"];
               }
               let lugar = self.model.LugarExpedicion;    
               if( self.model.receptor.rfc != 'XAXX010101000' ){
                    lugar =  self.model.receptor.domicilio.codigo_postal;
               }

                self.timbre = {
                    "Version": "4.0",
                    "SubTotal": subtotal,
                    "Total": total,
                    "Serie": "",
                    "Folio": "",
                    "Exportacion": "01",
                    "NoCertificado": "",
                    "Fecha": this.model.FechaPago + 'T00:00:00',
                    "Moneda": "MXN",
                    "TipoDeComprobante": "E",
                    "LugarExpedicion": self.model.LugarExpedicion,
                    "MetodoPago":self.model.MetodoPago,
                    "FormaPago":self.model.FormaPago,
                    "Emisor": {
                        "Nombre": self.model.emisor.razon_social,
                        "RegimenFiscal": self.model.emisor.regimen,
                        "Rfc": self.model.emisor.rfc,
                         "Domicilio": {
                            "Calle": self.model.emisor.domicilio.calle,
                            "CodigoPostal": self.model.emisor.domicilio.codigo_postal,
                            "Colonia": self.model.emisor.domicilio.colonia,
                            "Estado": self.model.emisor.domicilio.estado,
                            "Localidad": self.model.emisor.domicilio.localidad,
                            "Municipio": self.model.emisor.domicilio.municipio,
                            "NumeroExterior": self.model.emisor.domicilio.numero_ext,
                            "Pais": self.model.emisor.domicilio.pais,
                            "Referencia": ""
                        },
                    },
                    "Receptor": {
                        "Rfc": self.model.receptor.rfc,
                        "Nombre": self.model.receptor.razon_social,
                        "UsoCFDI": "CP01",
                        "RegimenFiscalReceptor": self.model.receptor.regimen_fiscal_receptor,
                        "DomicilioFiscalReceptor": lugar,
                        "Domicilio": {
                            "Calle": self.model.receptor.domicilio.calle,
                            "CodigoPostal": self.model.receptor.domicilio.codigo_postal,
                            "Colonia": self.model.receptor.domicilio.colonia,
                            "Estado": self.model.receptor.domicilio.estado,
                            "Localidad": self.model.receptor.domicilio.localidad,
                            "Municipio": self.model.receptor.domicilio.municipio,
                            "NumeroExterior": self.model.receptor.domicilio.numero_ext,
                            "Pais": self.model.receptor.domicilio.pais,
                            "Referencia": ""
                        },
                        "Email": self.model.receptor.email
                    },
                    "CfdiRelacionados":
                    [{"TipoRelacion":self.model.TipoRelacion,
                     "UUIDS":[self.model.UUID]}],
                    "Conceptos": [{
                        "Cantidad": "1",
                        "ClaveProdServ": "84111506",
                        "ClaveUnidad": "ACT",
                        "Descripcion": self.model.Descripcion,
                        "Importe": subtotal,
                        "ValorUnitario": subtotal,
                        "ObjetoImp": "02",
                        "Descuento":"0.00",
                        "Impuestos": impuestos}
                ],
                "Descuento":"0.00",
                "Impuestos": impuestos2 
                };
                if (parseInt(self.model.folio) > 0) {
                    self.timbre.Folio = self.model.folio;
                }
                self.timbre.Serie = self.model.serie;
                this.$root.$dialogLoader.hide();
                this.enviarTimbrar();

            }
        },

    },
   async created() {
    let self = this;
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        this.rules = this.$rules;
        this.usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
        this.model.uuid_empresa = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa")));
        

        this.URL = this.$hostname + "carta_porte/catalogos/";
        this.URL_ADM = this.$hostname + "carta_porte/administracion/";
        this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";

        await this.cargarEmisor();
        await this.cargarReceptores();
        await this.cargarCatalogosSAT();
     
        let folio = this.$local_storage.get('UUID');
        
      /*   var f_a = new Date();
        let y = f_a.getFullYear();
        let m = f_a.getMonth() + 1;
        let d = f_a.getDate();

        if (m < 10)
            m = '0' + m;

        if (d < 10)
            d = '0' + d;

        let fecha_a = y + "-" + m + "-" + d;
        this.model.FechaPago = fecha_a; */
        this.model.FechaPago = moment().format("YYYY-MM-DD");
        let total = this.$local_storage.get('SUBTOTAL');
        if (folio != undefined && folio != ''){
            this.model.UUID = folio;
            this.model.Descripcion = " Pago de factura: " +  this.$local_storage.get('SERIE') + " " + this.$local_storage.get('FOLIO');
            this.model.Pago.Saldo = total;
            this.model.Pago.Pagado = total;
            this.model.Pago.Insoluto = 0.00;
        }
        this.impuestos = JSON.parse(this.$local_storage.get('IMPUESTOS'));
        
        if(this.impuestos != undefined){
            
            if(this.impuestos.Traslados != undefined && this.impuestos.Traslados.length > 0)
                {
                   
                    self.iva_traslado = (parseFloat(self.impuestos.Traslados[0].TasaOCuota) * 100).toFixed(2);
                }
            if(self.impuestos.Retenciones != undefined && self.impuestos.Retenciones.length > 0)
            {
                this.impuestos.Retenciones.forEach(function(x){
                    if(x.Impuesto == "001"){
                        self.isr_retenido= (( parseFloat(x.Importe) / parseFloat(total)) * 100).toFixed(2);
                    }
                    if(x.Impuesto == "002"){
                        self.iva_retenido = ((parseFloat(x.Importe) / parseFloat(total)) * 100).toFixed(2);
                    }
                })
            }
        }
            
        this.calcular_totales();

        this.$root.$dialogLoader.hide();
    },

};
</script>
